import { render, staticRenderFns } from "./assignDriver.vue?vue&type=template&id=6faa7d74&scoped=true&"
import script from "./assignDriver.vue?vue&type=script&lang=js&"
export * from "./assignDriver.vue?vue&type=script&lang=js&"
import style0 from "./assignDriver.vue?vue&type=style&index=0&id=6faa7d74&scoped=true&lang=css&"
import style1 from "./assignDriver.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6faa7d74",
  null
  
)

export default component.exports